import { Stepper as MantineStepper, StepperProps as MantineStepperProps } from '@mantine/core';
import classNames from './Progress.module.css';

export const Progress: typeof MantineStepper = Object.assign(
    ({ children, ...props }: MantineStepperProps) => {
        return (
            <MantineStepper {...props} className={classNames.base}>
                {children}
            </MantineStepper>
        );
    },
    MantineStepper
);
